import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetAllGetFeedListWebResponseByMemberId } from "../recommendFeed/model";
import CreateFeedForm from "../CreateFeedForm";
import { TextBtn } from "../../../../shared";
import MyFeedBottomSheet from "../myFeedBottomSheet";
import FeedCard from "../feedCard";

interface IProps {
  nickName?: string;
  onToastChange?: Function
  setInitLoading?: Function
}

const MyFeed = ({ nickName, onToastChange, setInitLoading }: IProps) => {
  const navigate = useNavigate();
  const {
    data: feedList = [],
    isLoading,
    isSuccess
  } = useGetAllGetFeedListWebResponseByMemberId(Boolean(nickName));
  const [selectedFeed, setSelectedFeed] = useState<IGetMyFeedWebResponse>();
  const [isShowBottomSheet, setIsShowBottomSheet] = useState<boolean>(false);

  useEffect(() => {
    if (isSuccess) {
      setInitLoading?.(false)
    }

  }, [isSuccess])

  return (
    <>
      {nickName && (
        <div style={{ paddingInline: 20 }}>
          <CreateFeedForm nickName={nickName} />
        </div>
      )}
      <div>
        {feedList.length === 0 ? (
          <div style={{ textAlign: "center", paddingTop: "17.67vh" }}>
            <div
              className="body/b2 secondary/s600"
              style={{ marginBottom: "8px" }}
            >
              아직 게시된 글이 없습니다.
              <br />
              커뮤니티 첫 글을 써보세요!
            </div>
            <TextBtn
              onClick={() =>
                navigate(
                  "/create/feed?placeholder=요즘 발견한 나만의 웰니스 루틴은?"
                )
              }
              classNames={{ children: "secondary/s800" }}
              styles={{
                container: { padding: "var(--space4)" },
                children: { textDecorationColor: "var(--secondarys800)" },
              }}
              type="underline"
              icon={false}
            >
              글쓰기
            </TextBtn>
          </div>
        ) : (
          feedList.map((feed) => (
            <FeedCard
              key={feed.id}
              feed={feed}
              setSelectedFeed={setSelectedFeed}
              setIsShowBottomSheet={setIsShowBottomSheet}
              isLoading={isLoading}
              isMyFeed={true}
            />
          ))
        )}
      </div>
      <MyFeedBottomSheet
        selectedFeed={selectedFeed}
        isShowBottomSheet={isShowBottomSheet}
        setIsShowBottomSheet={setIsShowBottomSheet}
        onToastChange={onToastChange}
      />
    </>
  );
};

export default MyFeed;
